import { defineComponent as _defineComponent } from 'vue'
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarningSplash',
  props: {
  type: {
    type: String,
    default: 'warning',
  },
  icon: {
    type: String,
    default: 'tab_close',
  },
  heading: {
    type: String,
    default: '',
  },
  subHeading: {
    type: String,
    default: '',
  },
},
  setup(__props) {



return { __sfc: true,MaterialIcon }
}

})